import React from 'react';

import { Grid, IconButton, Typography, XCloseIcon } from '@metarouter-private/mr-mui';

import { useDrawerContext } from 'app/shared/contexts/drawer';

export default function DebuggerDrawerHeader() {
  const { drawer } = useDrawerContext();
  const { data, onClose } = drawer;
  const { eventData } = data;
  const { normalizedEventName } = eventData;

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid container item xs={8}>
        <Typography variant="h6">{normalizedEventName}</Typography>
      </Grid>

      <Grid item>
        <IconButton onClick={onClose}>
          <XCloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
